module.exports = __webpack_public_path__ + "assets/hide.c07853cf.svg";